import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

import {
  Box,
  Stack,
  Typography,
} from "@mui/material";

import { AppEmptyStateProps } from "./types";

const AppEmptyState = ({
  title = "No Data Found",
  description = "There are no records available at the moment.",
  icon,
  action,
}: AppEmptyStateProps) => {
  return (
    <Box
      py={8}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Stack
        spacing={2}
        alignItems="center"
        textAlign="center"
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            display: "grid",
            placeItems: "center",
            borderRadius: 2,
            bgcolor: "action.hover",
            color: "primary.main",
          }}
        >
          {icon ?? <InboxOutlinedIcon sx={{ fontSize: 36 }} />}
        </Box>

        <Typography
          variant="h6"
          fontWeight={800}
        >
          {title}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          maxWidth={420}
        >
          {description}
        </Typography>

        {action}
      </Stack>
    </Box>
  );
};

export default AppEmptyState;
